"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeatmapConfigSelector = void 0;
var create_selector_1 = require("../../../../state/create_selector");
var common_1 = require("../../../../utils/common");
var config_1 = require("../../layout/config/config");
var get_heatmap_spec_1 = require("./get_heatmap_spec");
exports.getHeatmapConfigSelector = create_selector_1.createCustomCachedSelector([get_heatmap_spec_1.getHeatmapSpecSelector], function (spec) {
    return common_1.mergePartial(config_1.config, spec.config, { mergeOptionalPartialValues: true });
});
//# sourceMappingURL=get_heatmap_config.js.map